import { Loan } from "./data/types";
import { useNow } from "./NowProvider";

function calculateTimestamps(loan: Loan, now: number) {
  const { repaymentCount, originationTimestamp } = loan.loanState;

  /* For the first period, the "previous deadline" is origination itself */
  const previousDeadline = repaymentCount > 0 ? loan.loanState.deadlines[repaymentCount - 1] : originationTimestamp;

  const remainingUntilRepaymentDeadLine = loan.nextDeadline - now;
  /* Past the next deadline — borrower is late, grace period interest accrues */
  const isGracePeriod = remainingUntilRepaymentDeadLine <= 0;
  /* Past the previous deadline — a repayment is now due */
  const isRepayment = now > previousDeadline;

  return { isRepayment, isGracePeriod, remainingUntilRepaymentDeadLine };
}

/**
 * Derived purely from the loan and the page's shared clock — no timer of its
 * own. Every caller therefore sees the same instant, so a loan's status, its
 * due note and its overdue banner cannot disagree about a lapsed deadline.
 *
 * Anything else that formats the current time (`formatDueNote`, say) must take
 * {@link useNow}'s value too, rather than reading the clock itself: this hook
 * returns a fresh object each render, and depending on that to trigger a
 * repaint is what previously made countdowns tick by accident.
 */
export function useLoanTimestamps(loan: Loan) {
  return calculateTimestamps(loan, useNow());
}
